import React from 'react';
import { useDidMount } from 'rooks';
import PropTypes from 'prop-types';

import * as audioFunctions from 'root/lib/audioFunctions';
import useAudioPlayer from 'lib/hooks/useAudioPlayer';
import {
  Background, Burst, OliviaIcon, TitleTextContainer,
  TitleText, DescriptionTextContainer, DescriptionText,
  QuestionTextContainer, QuestionText, ContinueButton,
} from './styledComponents';
import BackgroundSvg from './svgs/Bg.svg';
import OliviaIconSvg from './svgs/BigOlivia.svg';
import BurstSvg from './svgs/Burst.svg';
import Loader from '../../../Loader';
import { ModalContainer } from '../sharedComponents';

const titleText = 'SUCCESS';

const descriptionText = 'Challenges Met!';

const questionText = 'You mastered three challenges in a row. Your skills are improving. ' +
'I\'m resetting the portal with a new round of challenges.';

const ChallengeQuestSuccessModal = ({ closeModal }) => {
  const { playAudio } = useAudioPlayer();

  const handleClick = () => {
    audioFunctions.playTap();
    closeModal();
  };

  useDidMount(() => {
    playAudio(Loader.getLoadedAsset('sfx_hub_portal_output.mp3'));
  });

  return (
    <ModalContainer
      role="dialog"
      aria-modal="true"
      aria-labelledby="challenge-success-modal-title"
      data-dd-action-name="workshop-challenge-success-modal"
    >
      <Background>
        <img src={BackgroundSvg} alt="" />
      </Background>
      <Burst>
        <img src={BurstSvg} alt="" />
      </Burst>
      <OliviaIcon>
        <img src={OliviaIconSvg} alt="Olivia" />
      </OliviaIcon>
      <TitleTextContainer>
        <TitleText id="challenge-success-modal-title">
          {titleText}
        </TitleText>
      </TitleTextContainer>
      <DescriptionTextContainer>
        <DescriptionText>
          {descriptionText}
        </DescriptionText>
      </DescriptionTextContainer>
      <QuestionTextContainer>
        <QuestionText>
          {questionText}
        </QuestionText>
      </QuestionTextContainer>
      <ContinueButton
        onClick={handleClick}
        data-dd-action-name="workshop-challenge-success-modal:continue"
      >
        Continue
      </ContinueButton>
    </ModalContainer>
  );
};

export default ChallengeQuestSuccessModal;

ChallengeQuestSuccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};
